<!-- Area Chart - Chart.js Implementation -->
<div class="area-chart-container" #chartContainer>
  <div class="chart-container" [style.width.px]="view[0]" [style.height.px]="view[1]">
    <canvas baseChart 
      [data]="areaChartDataConfig" 
      [type]="areaChartType" 
      [options]="areaChartOptions"
      (chartClick)="onChartSelect($event)"
      (chartHover)="onChartActivate($event)">
    </canvas>
  </div>
  
  <!-- Custom Legend - Show which brand each area represents -->
  <div class="area-chart-legend" *ngIf="areaChartDataConfig.datasets && areaChartDataConfig.datasets.length > 0">
    <div class="legend-title" *ngIf="legendTitle">{{ legendTitle }}</div>
    <div class="legend-items">
      <div class="legend-item" *ngFor="let dataset of areaChartDataConfig.datasets; let i = index">
        <div class="legend-color" [style.background-color]="dataset.backgroundColor" [style.border-color]="dataset.borderColor"></div>
        <span class="legend-label">{{ dataset.label }}</span>
      </div>
    </div>
  </div>
</div>
